// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ScopeLinesSection_LineItemFragment = { __typename?: 'CommitmentLineItem', id: string, quantity?: number | null | undefined, internalNote?: string | null | undefined, primaryBidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, forCoveringTakeoffs: boolean } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, displayLocationPath: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, task?: { __typename?: 'Task', id: string, name: string } | null | undefined, materialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }
      | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }
      | { __typename?: 'ProjectCustomItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }
      | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }
      | { __typename?: 'TakeoffLineItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }> }
     | null | undefined } };

export const ScopeLinesSection_LineItemFragmentDoc = gql`
    fragment ScopeLinesSection_LineItem on CommitmentLineItem {
  id
  quantity
  internalNote
  primaryBidContractLineItem {
    id
    forCoveringTakeoffs
  }
  projectItem {
    id
    displayName
    item {
      id
      fullCode
    }
    location {
      id
      displayLocationPath
    }
    unitOfMeasure {
      id
      name
    }
    task {
      id
      name
    }
    materialVariant {
      id
      code
    }
    itemTemplateItem {
      id
      options {
        id
        name
      }
    }
  }
}
    `;